import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../theme/Component/usePaginator";
import { useEffect, useState } from "react";
import { _single, _UBLInvoice } from "../../../../core/services/dataBean/EntityCatalog";
import { MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicMultiSelecTable";
import { BasicTable, MASK_BOOLEAN } from "../../../theme/Component/BasicTable";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { UBLPayment } from "../UBLPayment/UBLPayment";
import { CreateUBLInvoiceItems } from "../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/CreateUBLInvoiveItem";
import { HistoryUBLInvoice } from "../../../contract/etapa-contrato/contrac/ublinvoice/HistoryUBLInvoice";
import { FireElectronicDocument } from "../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/FireElectronicDocument";
import { AccountantDocumentList } from "../../../contract/etapa-contrato/contrac/ublinvoice/AccountantDocumentList/AccountantDocumentList";
import { SelectAccountantConceptCatalogForSalesInvoice } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSalesInvoice";
import { SelectAccountantConceptCatalogForSupplierInvoice } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSupplierInvoice";
import { FileInput } from "../../../theme/Component/FileInput";
import { MakeUBLInvoice } from "../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectUBLSoftwareDispatcherByEnvironmentType } from "../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/Selectores/SelectUBLSoftwareDispatcherByEnvironmentType";
import { DocumentPDF, DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { SelectStoreEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { PrepaidPaymentEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/ComponentPrepaidPayment/PrepaidPaymentEditor";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { CurrencyEditor } from "../../../erp/cellEditor/Currency/CurrencyEditor";
import { SelectUBLDocumentPaymentType } from "../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/Components/SelectUBLDocumentPaymentType";
import { ReciablePaymentEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/ComponentPrepaidPayment/ReciablePaymentEditor";
import { UBLPaymentMeansEditor } from "../../../Inventories-Warehouses/Product/UBLPaymentMeans/UBLPaymentMeansEditor";
import { UBLPaymentMeansCodeEditor } from "../../../Inventories-Warehouses/Product/UBLPaymentMeansCode/UBLPaymentMeansCodeEditor";
import { SelectAccountantConceptForCashDesk } from "../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/SelectAccountantConceptForCashDesk";
import { SelectProject } from "../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { SelectBusinessCore } from "../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { AccountEditor } from "../../../editor/AccountEditor";
import { InventoryRemissionFactory } from "../../../RemoteAbstractAction/components/account/documents/inventoryremission/InventoryRemissionFactory/InventoryRemissionFactory";
import { UBLInvoiceFactory } from "../../../RemoteAbstractAction/components/account/documents/ublsalesaccountantdocument/UBLInvoiceFactory/UBLInvoiceFactory";
import { EditorPriceList } from "../../../Factoty&Production/PriceList/EditorPriceList";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";
import { UBLNotification } from "../../../contract/etapa-contrato/contrac/ublinvoice/UBLNotification/UBLNotification";
import { UBLInvoiceTaxSupplier } from "../../../contract/etapa-contrato/contrac/UBLInvoiceSupplier/Component/UBLInvoiceTax/UBLInvoiceTaxSupplier";
import { FileService } from "../../../../core/services/FileService";

type UBLInvoiceBean = {
    IDUBLInvoice: number,
    IssueDate: any,
    [key: string]: unknown;
}

type FormularioData = {
    Observations: string;
    NewDate: any;
}

interface UBLNotificationComponent {
    ublInvoice: UBLInvoiceBean;
}


const PURCHASE_INVOICE = 0;
const BILL_OF_SALE = 1;

export const UBLInvoiceAdjustment = ({ ublInvoice }: UBLNotificationComponent) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLInvoice);
    const paginador = usePaginator();
    const fileService = new FileService();


    const [notifyTarget, setNotifyTarget] = useState<"email" | "siif" | null>(null);

    const [obs, setObs] = useState<string>("");
    const [formulario, setFormulario] = useState<Partial<FormularioData>>({});

    const [bussinesLine, setBussinesLine] = useState<string>("");
    const [documentError, setDocumentError] = useState<any>([]);
    const [document, setDocument] = useState<any>([]);
    const [recordDate, setRecordDate] = useState<any>();
    const [formato, setFormato] = useState<any>(null)
    const [type, settype] = useState<any>([]);
    const [store, setStore] = useState<number>(null)
    const [disableProject, setDisableProject] = useState<boolean>(false);
    const [dataUBL, setDataUBL] = useState<string>("");
    const [ublsoftware, setUblSofteare] = useState<number>();


    const modalCredit = useModal("", MODAL_md);
    const modalDebit = useModal("", MODAL_md);

    useEffect(() => {
        if (ublInvoice.IDUBLInvoice && ublInvoice.IssueDate) {
            getLista();
        }
    }, [ublInvoice.IDUBLInvoice])

    const sendNotification = () => {
        if (notifyTarget === "email") {
            notifyEmail();
            return;
        }

        if (notifyTarget === "siif") {
            notifySiif();
            return;
        }

        toast.error("Debe seleccionar un tipo de notificación.");
    }

    const getLista = () => {
        instance.getUblInvoiceAdjustmentList(ublInvoice.IDUBLInvoice, ublInvoice.IssueDate).then(
            (resp) => {
                resp.forEach((user) => {
                    user.DataBeanProperties.Client = (user.DataBeanProperties.AccountCustomerNit ?? "") + "-" + (user.DataBeanProperties.AccountCustomerName ?? "");
                    user.DataBeanProperties.Doc = `${user.DataBeanProperties.FCIDDocument ? `${user.DataBeanProperties.FCMnemonic ?? ""} - ${user.DataBeanProperties.FCConsecutive ?? ""} - ${user.DataBeanProperties.FCDate ?? ""}` : "N/A"}`
                    user.DataBeanProperties.Remision = `${user.DataBeanProperties.EAFConsecutive ? `${user.DataBeanProperties.EAFMnemonic ?? ""} - ${user.DataBeanProperties.EAFConsecutive ?? ""} - ${user.DataBeanProperties.EAFDate ?? ""}` : "N/A"}`
                    user.DataBeanProperties.Obligation = `${user.DataBeanProperties.OBConsecutive ? `${user.DataBeanProperties.OBMnemonic ?? ""} - ${user.DataBeanProperties.OBConsecutive ?? ""} - ${user.DataBeanProperties.OBDate ?? ""}` : "N/A"}`
                });
                setLista(resp);
                setBean({});
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const notifyEmail = () => {
        const props = {
            message: obs,
        }
        instance.notifyInvoiceEmail(_single.getAccountID(), bean.IDUBLInvoice, bean.IssueDate, props).then(
            (resp) => {
                console.log(resp.OK);
                if (resp.OK) {
                    toast.success(resp.OK)
                }
                else if (resp.ERR) {
                    toast.warning(resp.ERR)
                }
                else {
                    toast.error("")
                };

                sendNotify.close();
                setObs("");
            }
        ).catch(err => { toast.error(err) })
    }

    const notifySiif = () => {
        if (bussinesLine.trim().length === 0) {
            toast.error("Linea de Negocio es Requerido");

            return;
        }
        const props = {
            message: obs,
            BusinessLine: bussinesLine,
        }
        instance.notifyInvoiceSIIFByEmail(_single.getAccountID(), bean.IDUBLInvoice, bean.IssueDate, props).then(
            (resp) => {
                if (resp.OK) {
                    toast.success(resp.OK)
                }
                else if (resp.ERR) {
                    toast.warning(resp.ERR)
                }
                sendNotify.close();
                setObs("");
                setBussinesLine("");
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Nit-Cliente', property: 'Client', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Nit - Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Aplicar Anticipo', property: 'ApplyPrepaidValue', visible: true, mask: MASK_BOOLEAN },
        { title: 'Valor del Anticipo', property: 'PrepaidPayment', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Documento Factura', property: 'Doc', visible: true },
        { title: 'Documento Obligacion', property: 'Obligation', visible: true },
        { title: 'Entrada de Almacén/Remisión', property: 'Remision', visible: true },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true, mask: MASK_BOOLEAN },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentTypeName', visible: true },
        { title: 'Días de Vencimiento', property: 'DefeatDays', visible: true },
        { title: 'Utilizar Otra Moneda', property: 'UseOtherCurrency', visible: true },
        { title: 'Moneda de la Transacción', property: 'CurrencyName', visible: true },
        { title: 'Tasa de cambio', property: 'ExchangeRate', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar Nota Crédito', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { modalCredit.open("Agregar nota Crédito") } },
        { nombre: 'Agregar Nota Debito', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { modalDebit.open("Agregar Nota Débtido") } },
    ]

    const createCreditNote = () => {
        if (!formulario.NewDate || !formulario.Observations) {
            toast.error("Los campos son obligatorios");
            return;
        }


        instance.createUBLInvoiceForCreditNoteFromUBLInvoice(formulario.NewDate, ublInvoice.IDUBLInvoice, ublInvoice.IssueDate, formulario.Observations, _single.getAccountID()).then(
            (resp) => {
                getLista();
                modalCredit.close();
                setFormulario({});
            }
        ).catch(err => { toast.error(err) });
    }

    const createDebitNote = () => {
        if (!formulario.NewDate || !formulario.Observations) {
            toast.error("Los campos son obligatorios");
            return;
        }
        instance.createUBLInvoiceForDebitNoteFromUBLInvoice(formulario.NewDate, ublInvoice.IDUBLInvoice, ublInvoice.IssueDate, formulario.Observations, _single.getAccountID()).then(
            (resp) => {
                getLista();
                modalDebit.close();
                setFormulario({});
            }
        ).catch(err => { toast.error(err) });
    }

    const updateDesciption = () => {
        instance.setDescriptionToUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, bean.Description).then(
            (resp) => {
                getLista();
                setModalDescription({ ...modalDescription, view: false });
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const updateAccountantConcept = () => {
        instance.setAccountantConceptToUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, bean.IDAccountantConcept).then(
            (resp) => {
                getLista();
                setModalConcept({ ...modalConcept, view: false });
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const updateInvoice = () => {
        if (bean.ApplyPrepaidValue) {
            if (!bean.PrepaidIDAccountantStr || bean.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!bean.PrepaidPayment || isNaN(bean.PrepaidPayment) || bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }

        instance.updateUBLInvoice(bean).then(() => {
            getLista();
            setModalApplyPrepaid({ ...modalApplyPrepaid, "view": false });
            setModalDocument({ ...modalDocument, view: false });
            modalEdit.close();
        }).catch(err => {
            console.log(err);
            toast.error("No se pudo realizar la acción.");
        });
    };

    const update = () => {
        setModalUBL({ ...modalUBL, "view": false });
        getLista();
    }

    const createAccountantDocumentForUBLInvoice = () => {
        instance.createAccountantDocumentForUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, recordDate, _single.getAccountID())
            .then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList) {
                        setDocumentError(resp.MsgList);
                    }
                    if (resp.DocumentURL) {
                        let docs: DocumentPDF[] = [];
                        resp.DocumentURL.forEach(element => {
                            docs.push({
                                Filename: element.DataBeanProperties.Filename,
                                Media: element.DataBeanProperties.Media,
                                MediaContext: element.DataBeanProperties.MediaContext,
                                Type: element.DataBeanProperties.Type,
                                URLLink: element.DataBeanProperties.URLLink
                            })
                        });
                        setDocument(docs);
                    }
                    setModalVisor({ ...modalVisor, "view": true, "name": "Causación Contable" });
                    setModalAccounting({ ...modalAccounting, "view": false });
                    getLista();
                }
            ).catch(err => toast.error(err));
    }

    const getElectronicDocumentProforma = () => {

        instance.getElectronicDocumentProforma(
            bean.IDUBLInvoice,
            bean.IssueDate,
            _single.getAccountID(),
            ublsoftware
        ).then((resp: any) => {

            console.log("RESP:", resp);

            let data = resp;
            if (!data?.MediaContext || !data?.Media) {
                console.warn("No viene MediaContext o Media");
                toast.error("No se encontró el documento para visualizar");
                return;
            }

            const url = fileService.getUrlFile(data.MediaContext, data.Media);
            const type = getFileType(data.Media);

            settype(type);
            setFormato(url);
            setModalPro(prev => ({ ...prev, view: false }));
            setTimeout(() => {
                setModalviewdoc(prev => ({ ...prev, view: true }));
            }, 100);

        }).catch(err => {
            console.error(err);
            toast.error(err);
        });
    };

    const getFileType = (mediaName: string) => {
        let fileType = mediaName.split('.').pop()?.toLowerCase();
        return fileType;
    }

    const applyPreapid = () => {
        if (bean.ApplyPrepaidValue) {
            if (!bean.PrepaidIDAccountantStr || bean.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!bean.PrepaidPayment || isNaN(bean.PrepaidPayment) || bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }

        instance.applyPrepaidPayment(
            bean.IDUBLInvoice,
            bean.IssueDate,
            bean.ApplyPrepaidValue,
            bean.ApplyPrepaidValue ? bean.PrepaidIDAccountantStr : null,
            bean.ApplyPrepaidValue ? bean.PrepaidPayment : null
        ).then(() => {
            getLista();
            setModalPrepaid({ ...modalPrepaid, "view": false });
        }).catch(err => {
            console.log(err);
            toast.error("No se pudo realizar la acción.");
        });
    };

    const generateEntry = () => {
        instance.createFixedAssetEntryForUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, _single.getCurrenDate(), store, _single.getAccountID()).then(
            (resp: any) => {
                //console.log(resp);
                if (resp.MsgList) {
                    setDocumentError(resp.MsgList);
                }
                if (resp.DocumentURL) {
                    let docs: DocumentPDF[] = [];
                    resp.DocumentURL.forEach(element => {
                        docs.push({
                            Filename: element.DataBeanProperties.Filename,
                            Media: element.DataBeanProperties.Media,
                            MediaContext: element.DataBeanProperties.MediaContext,
                            Type: element.DataBeanProperties.Type,
                            URLLink: element.DataBeanProperties.URLLink
                        })
                    });
                    setDocument(docs);
                }
                setModalVisor({ ...modalVisor, "view": true, "name": "Documento de Entrada" });
                setModalEntry({ ...modalEntry, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err)
                toast.error("No se Pudo Realizar la Accion")
            }
        )
    }

    const nullUBL = () => {
        instance.nullifyUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, _single.getAccountID(), obs).then(
            (resp) => {
                getLista();
                if (resp.length > 0) {
                    resp.map((e) => {
                        setModalConfirm({ ...ModalConfirm, "view": false });
                        toast.info(e, { autoClose: false });
                    });
                } else {
                    toast.error("No se ha podido anular la factura.")
                }
            }
        ).catch(
            err => {
                console.log(err);
            }
        )
    }

    const modalEdit = useModal("Editar Factura", MODAL_LG)
    const modalConfig = useModal("Especificar Divisa", MODAL_md)
    const modalConfig2 = useModal("Terminos de Pago", MODAL_md);
    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalPro, setModalPro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalB, setModalB] = useState<any>({ view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalFire, setModalFire] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalSeeDoc, setModalSeeDoc] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalUBL, setModalUBL] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalAccounting, setModalAccounting] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalVisor, setModalVisor] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalEntry, setModalEntry] = useState<any>({ name: 'Generar Entrada', view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalPrepaid, setModalPrepaid] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalApplyPrepaid, setModalApplyPrepaid] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalRetenciones, setModalRetenciones] = useState<any>({ view: false, btnClose: true, btnSubmit: false, format: 'modal-xl' });
    const [modalDescription, setModalDescription] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConcept, setModalConcept] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalDocument, setModalDocument] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalRadian = useModal("Eventos Radian", MODAL_LG);
    const modalAdjustmen = useModal("Notas de Ajuste", MODAL_LG);
    const [ModalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalfac, setModalfac] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const sendNotify = useModal("", MODAL_md);


    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-line', visible: true, evento: () => { modalEdit.open(`Editar factura 1`) } },
            { titulo: 'ver Items de la Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalB({ ...modalB, "view": true, "name": `Items de la Factura` }) } },
            { titulo: 'Eventos Radian', icono: 'ri-list-check', visible: _single.canView(), evento: () => { modalRadian.open() } },
            { titulo: 'Ver pagos de Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalfac({ ...modalfac, "view": true, "name": `Ver pagos de Factura` }) } },
            { titulo: 'Notas de Ajuste', icono: 'ri-list-check', visible: bean.UBLDocumentType == 0 || bean.UBLDocumentType == 1, evento: () => { modalAdjustmen.open(); } },
            { titulo: 'Ver Retenciones de la Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalRetenciones({ ...modalRetenciones, "view": true, "name": `Items de la Factura ${bean.IDUBLInvoice}` }) } },
            { titulo: 'Ver Documentos Contables', icono: 'ri-list-ordered', visible: true, evento: () => { setModalSeeDoc({ ...modalSeeDoc, "view": true, "name": `Ver Documentos Contables` }) } },
            { titulo: 'Ver eventos en la Factura', icono: 'ri-history-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true, "name": "Ver eventos en la Factura" }) } },
            { titulo: 'Agregar/Modificar Documento de Factura', icono: 'ri-swap-line', visible: true, evento: () => { setModalDocument({ ...modalDocument, "name": "Modificar Documento Cargado", "view": true }) } },
            { titulo: 'Especificar Divisa', icono: 'ri-money-dollar-box-line', visible: true, evento: () => { modalConfig.open() } },
            { titulo: 'Terminos de Pago', icono: 'ri-money-dollar-box-line', visible: true, evento: () => { modalConfig2.open() } },
            { titulo: 'Crear/Modificar Objeto de Factura', icono: 'ri-file-list-line', visible: true, evento: () => { setModalDescription({ ...modalDescription, "name": "Crear/Modificar Objeto de Factura", "view": true }) } },
            { titulo: 'Crear/Modificar Concepto de Ingreso', icono: 'ri-file-list-line', visible: true, evento: () => { setModalConcept({ ...modalConcept, "name": "Crear/Modificar Concepto de Ingreso", "view": true }) } },
            { titulo: 'Cruzar Anticipo', icono: 'ri-swap-box-line', visible: bean.UBLDocumentType === 1, evento: () => { setModalPrepaid({ ...modalPrepaid, "view": true, "name": "Cruzar Anticipo" }) } },
            { titulo: 'Aplicar Anticipo', icono: 'ri-money-dollar-circle-line', visible: (bean.ApplyPrepaidValue === true && bean.UBLDocumentType === 1), evento: () => { setModalApplyPrepaid({ ...modalApplyPrepaid, "view": true, "name": "Aplicar Anticipo" }) } },
            { titulo: 'Generar Factura Proforma', icono: 'ri-swap-box-line', visible: true, evento: () => { setModalPro({ ...modalPro, "view": true }) } },
            { titulo: 'Generar Causación Contable', icono: 'ri-save-line', visible: true, evento: () => { setModalAccounting({ ...modalAccounting, "view": true, "name": `Generar Causación Contable` }) } },
            { titulo: 'Transmitir/Descargar Documento Electrónico', icono: 'ri-list-ordered', visible: true, evento: () => { setModalFire({ ...modalFire, "view": true, "name": `Transmitir/Descargar Documento` }) } },
            { titulo: 'Generar Entrada a Activos Fijos', icono: 'ri-save-line', visible: bean.UBLDocumentType === 1, evento: () => { setModalEntry({ ...modalEntry, "view": true, "name": `Generar Entrada Almacen` }) } },
            { titulo: 'Anular', icono: 'ri-forbid-line', visible: true, evento: () => { setModalConfirm({ ...ModalConfirm, "view": true, "name": "Anular Factura" }); } },
        ]

        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} />

                <Modal modal={modalCredit.modal} updateModal={modalCredit.setModal} eventModal={() => { createCreditNote() }}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate label="Fecha de Nota Crédito" name="NewDate" value={formulario.NewDate} setDate={(e) => { setFormulario({ ...formulario, NewDate: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="">Observaciones</label>
                            <textarea className="form-control" value={formulario.Observations} onChange={(e) => { setFormulario({ ...formulario, Observations: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalDebit.modal} updateModal={modalDebit.setModal} eventModal={() => { createDebitNote() }}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate label="Fecha de Nota Débito" name="NewDate" value={formulario.NewDate} setDate={(e) => { setFormulario({ ...formulario, NewDate: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="">Observaciones</label>
                            <textarea className="form-control" value={formulario.Observations} onChange={(e) => { setFormulario({ ...formulario, Observations: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalCredit.modal} updateModal={modalCredit.setModal} eventModal={() => { createCreditNote() }}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate label="Fecha de Nota Crédito" name="NewDate" value={formulario.NewDate} setDate={(e) => { setFormulario({ ...formulario, NewDate: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="">Observaciones</label>
                            <textarea className="form-control" value={formulario.Observations} onChange={(e) => { setFormulario({ ...formulario, Observations: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalCredit.modal} updateModal={modalCredit.setModal} eventModal={() => { createCreditNote() }}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate label="Fecha de Nota Crédito" name="NewDate" value={formulario.NewDate} setDate={(e) => { setFormulario({ ...formulario, NewDate: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="">Observaciones</label>
                            <textarea className="form-control" value={formulario.Observations} onChange={(e) => { setFormulario({ ...formulario, Observations: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalfac} updateModal={setModalfac} >
                    <UBLPayment idUBLInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} />
                </Modal>
                <Modal modal={modalB} updateModal={setModalB} >
                    <CreateUBLInvoiceItems idUBLInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} _onChange={() => { getLista(); }} />
                </Modal>

                <Modal modal={modalC} updateModal={setModalC} >
                    <HistoryUBLInvoice _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
                </Modal>

                <Modal modal={modalFire} updateModal={setModalFire} evenOnClose={() => { getLista() }} >
                    <FireElectronicDocument _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} _obs={bean.Description ?? ''} _refresh={() => { getLista() }} />
                </Modal>

                <Modal modal={modalAdjustmen.modal} updateModal={modalAdjustmen.setModal} >
                    <UBLInvoiceAdjustment ublInvoice={bean} />
                </Modal>

                <Modal modal={modalSeeDoc} updateModal={setModalSeeDoc} >
                    <AccountantDocumentList _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
                </Modal>

                <Modal modal={modalDescription} updateModal={setModalDescription} eventModal={() => { updateDesciption() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalConcept} updateModal={setModalConcept} eventModal={() => { updateAccountantConcept() }} >
                    <div className="row">
                        {bean.UBLDocumentType == BILL_OF_SALE &&
                            <div className="col-md-12">
                                <label>Concepto de Ingreso de Facturación de Venta</label>
                                <SelectAccountantConceptCatalogForSalesInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
                            </div>
                        }
                        {bean.UBLDocumentType == PURCHASE_INVOICE &&
                            <div className="col-md-12">
                                <label>Concepto de Ingreso de Facturación Proveedor</label>
                                <SelectAccountantConceptCatalogForSupplierInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
                            </div>
                        }
                    </div>
                </Modal>

                <Modal modal={modalDocument} updateModal={setModalDocument} eventModal={() => { updateInvoice() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label>No Factura</label>
                            <input type="text" className="form-control" value={bean.InvoiceID} onChange={(e) => { setBean({ ...bean, InvoiceID: e.target.value }) }} />
                        </div>
                        <div className="col-md-12">
                            <FileInput onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }} Media={bean.Media} MediaContext={bean.MediaContext} label={bean.Media ? "Documento de la Factura Cargada" : "Cargar Documento de Factura"} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalUBL} updateModal={setModalUBL} eventModal={() => { update() }} >
                    <MakeUBLInvoice catalog _onChange={(e) => { console.log(e) }} />
                </Modal>

                <Modal modal={modalAccounting} updateModal={setModalAccounting} eventModal={createAccountantDocumentForUBLInvoice} onSubmitLabel="Procesar">
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate label="Fecha de registro contable" name="date" value={recordDate} setDate={setRecordDate} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalPro} updateModal={setModalPro} eventModal={getElectronicDocumentProforma}  >
                    <div className="row">
                        <div className="col-md-12">
                            <SelectUBLSoftwareDispatcherByEnvironmentType idSelector={ublsoftware} onChange={(e) => { setUblSofteare(e) }} />
                            {/* <SoftwareUBL render={bean.EnvironmentTypeName} idSelector={bean.IDUBLSoftwareDispatcher} onChange={(e) => { setBean({ ...bean, "IDUBLSoftwareDispatcher": e.IDUBLSoftwareDispatcher, "EnvironmentTypeName": e.EnvironmentTypeName }) }} label=" " returnType="Object" /> */}
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalVisor} updateModal={setModalVisor} >
                    <div className="row">
                        <div className="col-md-12">
                            {documentError.length > 0 ?
                                <ul className="group-list">
                                    {documentError.map((item: any, index: number) => {
                                        return (
                                            <li key={index} className="group-list-item">{item}</li>
                                        )
                                    })}
                                </ul>
                                :
                                <>
                                    {document.length > 0 &&
                                        <DocumentViewer list={document} />
                                    }
                                </>
                            }
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalEntry} updateModal={setModalEntry} onSubmitLabel="Generar Entrada"
                    eventModal={() => {
                        if (store == null || store == undefined || isNaN(store)) {
                            toast.error("Debe Seleccionar un almacen");
                        } else {
                            generateEntry();
                        }
                    }}
                >
                    <SelectStoreEditor idSelector={store} onChange={(e) => { setStore(e.IDStore) }} />
                </Modal>


                <Modal modal={modalPrepaid} updateModal={setModalPrepaid} eventModal={() => { applyPreapid() }}  >
                    <div className="row">
                        <div className="col-md-12">
                            <BasicSwitch label="Aplicar Anticipo" estado={bean.ApplyPrepaidValue} eventChange={(e) => { setBean({ ...bean, "ApplyPrepaidValue": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <PrepaidPaymentEditor _Invoice={bean} onChange={(e) => { setBean({ ...bean, "PrepaidIDAccountantStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-md-12">
                            <InputMoney _value={bean.PrepaidPayment} onChange={(e) => { setBean({ ...bean, "PrepaidPayment": e }) }} _label="Valor del Anticipo a Cruzar" />
                        </div>
                    </div>
                </Modal>

                <Modal modal={ModalConfirm} updateModal={setModalConfirm} eventModal={() => { nullUBL() }}  >
                    <div className="row">
                        <div className="col-md-6">
                            <strong>ID Factura </strong><small>{bean.IDUBLInvoice}</small>
                        </div>
                        <div className="col-md-6">
                            <strong>Fecha Factura </strong><small>{bean.IssueDate}</small>
                        </div>
                        <div className="col-md-12">
                            <label >Justificación</label>
                            <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                        </div>
                    </div>
                </Modal>


                <Modal modal={modalConfig.modal} updateModal={modalConfig.setModal} eventModal={updateInvoice} >
                    <div className="row">
                        <div className="col-md-12">
                            <BasicSwitch label="Utilizar Otra Moneda" estado={bean.UseOtherCurrency} eventChange={(e) => { setBean({ ...bean, UseOtherCurrency: e }) }} />
                        </div>
                        {bean.UseOtherCurrency &&
                            <>
                                <div className="col-md-12">
                                    <CurrencyEditor id={bean.IDCurrency} onchange={(e) => { setBean({ ...bean, IDCurrency: e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Tasa de cambio</label>
                                    <input type="number" className="form-control" value={bean.ExchangeRate} onChange={(e) => {
                                        const value = e.target.value ? parseFloat(e.target.value) : null;
                                        setBean({ ...bean, ExchangeRate: value })
                                    }} />
                                </div>
                            </>
                        }
                    </div>
                </Modal>

                <Modal modal={modalConfig2.modal} updateModal={modalConfig2.setModal} eventModal={updateInvoice} >
                    <div className="row">
                        <div className="col-md-12">
                            <SelectUBLDocumentPaymentType idSelector={bean.PaymentType} label="Tipo de Pago" onChange={(e) => { setBean({ ...bean, PaymentType: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Dias de Vencimiento</label>
                            <input type="number" className="form-control" value={bean.DefeatDays} onChange={(e) => {
                                const value = e.target.value ? Number(e.target.value) : null;
                                setBean({ ...bean, DefeatDays: value })
                            }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalApplyPrepaid} updateModal={setModalApplyPrepaid} eventModal={() => { updateInvoice() }}  >
                    <div className="row">
                        <div className="col-md-12">
                            <BasicSwitch label="Aplicar Anticipo" estado={bean.ApplyPrepaidValue} eventChange={(e) => { setBean({ ...bean, "ApplyPrepaidValue": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <ReciablePaymentEditor renderValue={bean.PrepaidIDAccountantStr} _Invoice={bean} onChange={(e) => { setBean({ ...bean, "PrepaidIDAccountantStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-md-12">
                            <InputMoney _value={bean.PrepaidPayment} onChange={(e) => { setBean({ ...bean, "PrepaidPayment": e }) }} _label="Valor del Anticipo a Cruzar" />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { updateInvoice() }}  >
                    <div className="row">
                        <div className="col-md-6">
                            <UBLPaymentMeansEditor
                                idSelector={bean.IDUBLPaymentMeans}
                                onChange={(e) =>
                                    setBean({
                                        ...bean,
                                        IDUBLPaymentMeans: e
                                    })
                                }
                            />
                        </div>
                        <div className="col-md-6">
                            <UBLPaymentMeansCodeEditor
                                idSelector={bean.IDUBLPaymentMeansCode}
                                onChange={(e) =>
                                    setBean({
                                        ...bean,
                                        IDUBLPaymentMeansCode: e
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="row">
                        {bean?.UBLDocumentType === 0 ?
                            <div className="col-md-6">
                                {bean?.IDCashReimbursement ?
                                    <>
                                        <label>Concepto de Ingreso de Facturación</label>
                                        <SelectAccountantConceptForCashDesk _label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
                                    </>
                                    :
                                    <>
                                        <label>Concepto de Ingreso de Facturación de Venta</label>
                                        <SelectAccountantConceptCatalogForSalesInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
                                    </>
                                }
                            </div>
                            :
                            <>
                                <div className="col-md-6">
                                    <label >Concepto de Ingreso de Facturación Proveedor</label>
                                    <SelectAccountantConceptCatalogForSupplierInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
                                </div>
                            </>

                        }

                        <div className="col-md-6">
                            <label>Almacen</label>
                            <SelectStoreEditor idSelector={bean.IDStore} onChange={(e) => { setBean({ ...bean, "IDStore": e.IDStore }) }} label=" " />
                        </div>

                        {bean?.UBLDocumentType === 1 &&
                            <>
                                <div className="col-md-6">
                                    <label>Proyecto</label>
                                    <SelectProject
                                        disabled={disableProject}
                                        label=" "
                                        idSelector={bean.IDProject}
                                        onChange={(value) => {
                                            if (!value) {
                                                setBean({
                                                    ...bean,
                                                    IDProject: null,
                                                    IDAccount: null,
                                                    IDBusinessCore: null
                                                });
                                                return;
                                            }

                                            const { IDProject, IDAccount, IDBusinessCore } = value;
                                            setBean({
                                                ...bean,
                                                IDProject: IDProject ?? null,
                                                IDAccountCustomer: IDAccount ?? null,
                                                IDBusinessCore: IDBusinessCore ?? null
                                            });
                                        }}
                                        returnType="Object"
                                    />

                                </div>
                                <div className="col-md-6">
                                    <label>Core de Negocio</label>
                                    <SelectBusinessCore label=" " idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <label >Consumidor</label>
                                    <AccountEditor idAccount={bean.IDAccountCustomer} label=" " onChange={(e) => { setBean({ ...bean, "IDAccountCustomer": e.IDAccount }); }} />
                                </div>
                            </>
                        }

                        {bean?.UBLDocumentType === 0 &&
                            <div className="col-md-6">
                                <label>Tercero</label>
                                <AccountEditor idAccount={bean.IDAccount} label=" " onChange={({ IDAccount }: any) => { setBean({ ...bean, "IDAccount": IDAccount }) }} />
                            </div>
                        }

                        <div className="col-md-6">
                            <FileInput Media={bean.Media} MediaContext={bean.MediaContext} label={`Archivo ${bean?.UBLDocumentType == 0 ? "Factura" : "Remisión"}`} directory="temp" onCreate={(e) => { setBean({ ...bean, "Media": e.Media, "MediaContext": e.MediaContext }) }} />
                        </div>

                        {bean?.UBLDocumentType === 1 &&
                            <>
                                <div className="col-md-6">
                                    <label>Traer Datos desde:</label>
                                    <select className="form-control" value={dataUBL} onChange={(e) => {
                                        setDataUBL(e.target.value);
                                        setDisableProject(false);
                                    }}>
                                        <option value="">...</option>
                                        <option value="Remision">Remisión</option>
                                        <option value="Third">Facturas Pagadas a Terceros por Proyecto</option>
                                    </select>
                                </div>
                                {dataUBL === "Remision" &&
                                    <div className="col-md-6">
                                        <InventoryRemissionFactory
                                            onChangeProyect={(value) => {
                                                const { IDProject, IDAccount, IDBusinessCore } = value;
                                                setBean({
                                                    ...bean,
                                                    IDProject: IDProject ?? null,
                                                    IDAccount: IDAccount ?? null,
                                                    IDBusinessCore: IDBusinessCore ?? null
                                                });
                                                if (IDProject) {
                                                    setDisableProject(true);
                                                } else {
                                                    setDisableProject(false);
                                                }
                                            }}
                                            onChange={(e) => { setBean({ ...bean, IFRDate: e.DocumentDate, IFRIDDocument: e.IDDocument }) }}
                                            label="Remisiones de Producto"
                                        />
                                    </div>
                                }
                                {dataUBL === "Third" &&
                                    <div className="col-md-6">
                                        <UBLInvoiceFactory
                                            onChange={(e) => {
                                                if (e.IDProject) {
                                                    setDisableProject(true);
                                                } else {
                                                    setDisableProject(false);
                                                }
                                                setBean({ ...bean, IFRDate: e.DocumentDate, IFRIDDocument: e.IDDocument, IDProject: e.IDProject })
                                            }}
                                            label="Factura Pagada a Terceros por Proyectos"
                                        />
                                    </div>
                                }
                                {dataUBL == "" &&
                                    <div className="col-md-6" />
                                }
                                <div className="col-md-6">
                                    <EditorPriceList selectFirstData={bean.IFRIDDocument} onChange={(e) => { setBean({ ...bean, IDPriceList: e.IDPriceList }) }} label="Listado de precios" />
                                </div>
                            </>
                        }

                        {bean?.UBLDocumentType === 1 &&
                            <>
                                <div className="col-md-6">
                                    <label >Número de {bean?.UBLDocumentType == 0 ? "Factura" : "Remisión"}</label>
                                    <input type="text" className="form-control" name="InvoiceID" value={bean.InvoiceID} onChange={(e) => { setBean({ ...bean, InvoiceID: e.target.value }) }} />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Documento Soporte" estado={bean.isDocumentSupport} eventChange={(e) => { setBean({ ...bean, "isDocumentSupport": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label >Fecha de Registro Contable</label>
                                    <InputDate notDate label=" " name="accountantDate" value={bean.accountantDate} setDate={(e) => { setBean({ ...bean, "accountantDate": e }) }} />
                                </div>
                            </>
                        }
                        <div className="col-md-6">
                            <label >Fecha de Factura</label>
                            <InputDate notDate label=" " name="IssueDate" value={bean.IssueDate} setDate={(e) => { setBean({ ...bean, "IssueDate": e }) }} />
                        </div>

                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="obs" className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} ></textarea>
                        </div>
                    </div>
                </Modal>
                <div className="col-md-12">
                    <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <VisorAnyDocument url={formato} type={type} />
                            </div>
                        </div>
                    </Modal>
                </div>


                <Modal modal={modalRadian.modal} updateModal={modalRadian.setModal} >
                    <UBLNotification ublInvoice={bean} />
                </Modal>

                <Modal modal={sendNotify.modal} updateModal={sendNotify.setModal} eventModal={sendNotification} >
                    <div className="row">
                        {notifyTarget == "siif" &&
                            <div className="col-md-12">
                                <label>Linea de Negocio</label>
                                <input type="text" className="form-control" value={bussinesLine} onChange={(e) => { setBussinesLine(e.target.value) }} />
                            </div>
                        }
                        <div className="col-md-12">
                            <label>Mensaje</label>
                            <textarea name="obs" className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} ></textarea>
                        </div>
                    </div>
                </Modal>

                <div className="col-md-12">
                    <Modal modal={modalRetenciones} updateModal={setModalRetenciones} >
                        <UBLInvoiceTaxSupplier idublInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} />
                    </Modal>
                </div>

            </div>
        </div>
    )
}